import AddIcon from '@mui/icons-material/Add';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import { Box, Button, Container, Stack, Typography } from '@mui/material';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import CreateOrganizationModal from '../components/organization/CreateOrganizationModal';
import { selectAuthenticated, selectIsSuperUser } from '../redux/reducers/authenticationReducer';
import { initialize as initCatalogs } from '../redux/reducers/catalogsReducer';
import { initializeStandardFrameworks } from '../redux/reducers/frameworkReducer';
import {
  initialize as initializeOrganizations,
  selectOrganization,
  selectOrganizationList,
} from '../redux/reducers/organizationReducer';

function OrganizationSelectionView() {
  const organizationList = useSelector(selectOrganizationList);
  const authenticated = useSelector(selectAuthenticated);
  const isSuperUser = useSelector(selectIsSuperUser);
  const [modalOpen, setModalOpen] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { t } = useTranslation();

  useEffect(() => {
    if (authenticated) {
      dispatch(initializeOrganizations());
      dispatch(initializeStandardFrameworks());
      dispatch(initCatalogs());
    }
  }, [authenticated, dispatch]);

  const handleSelection = (organizationId) => {
    dispatch(selectOrganization(organizationId));
    navigate('/home');
  };

  const handleModalOpen = () => {
    setModalOpen(true);
  };

  const handleCloseModal = () => {
    setModalOpen(false);
  };

  return (
    <>
      {modalOpen && <CreateOrganizationModal handleClose={handleCloseModal} />}
      <Container variant="organizationList" maxWidth="false">
        <Box display="flex" justifyContent="center">
          <Stack direction="column" width="40vw" justifyContent="space-around" alignItems="center">
            <Typography id='select-organization-title' variant="h6">{t('organization.selectTitle')}</Typography>
            {organizationList.map((org) => (
              <Stack direction="row" variant="itemRow" key={org.id} width="100%">
                <Typography variant="bold">{org.name}</Typography>
                <Button id={`select-${org.name}`} variant="contained" onClick={() => handleSelection(org.id)} endIcon={<ChevronRightIcon />}>
                  {t('organization.buttonSelect')}
                </Button>
              </Stack>
            ))}
          </Stack>
        </Box>
      </Container>
      {isSuperUser && (
        <Container maxWidth="false">
          <Box display="flex" justifyContent="space-around">
            <Button id='create-organization' variant="contained" onClick={() => handleModalOpen()} endIcon={<AddIcon />}>
              {t('organization.addNew')}
            </Button>
          </Box>
        </Container>
      )}
    </>
  );
}

export default OrganizationSelectionView;
